/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Question_5Inputs */

const en_help_center__account_n_technical__question_5 = /** @type {(inputs: Help_Center__Account_N_Technical__Question_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I check my bid balance?`)
};

/**
* | output |
* | --- |
* | "How do I check my bid balance?" |
*
* @param {Help_Center__Account_N_Technical__Question_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__question_5 = /** @type {((inputs?: Help_Center__Account_N_Technical__Question_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Question_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__question_5(inputs)
});